import { useWidgetData } from '../useWidgetData'

import { StatisticValueMetadata } from '../../../types/court/court'

export const useManagersWidget = () =>
  useWidgetData<StatisticValueMetadata>('managers')
